export const heroes = [
    {
        hero: 'Spider-man',
        heroImg: 'images/heroes/mc01en_card_spider-man.png',
        alterEgo: 'Peter Parker',
        alterEgoImg: 'images/heroes/mc01en_card_peter-parker.png',
        pack: 'Core Set',
    },
    {
        hero: 'Captain Marvel',
        heroImg: 'images/heroes/mc01en_card_captain-marvel.png',
        alterEgo: 'Carol Danvers',
        alterEgoImg: 'images/heroes/mc01en_card_carol-danvers.png',
        pack: 'Core Set',
    },
    {
        hero: 'She-Hulk',
        heroImg: 'images/heroes/mc01en_card_she-hulk.png',
        alterEgo: 'Jennifer Walters',
        alterEgoImg: 'images/heroes/mc01en_card_jennifer-walters.png',
        pack: 'Core Set',
    },
    {
        hero: 'Iron Man',
        heroImg: 'images/heroes/mc01en_iron-man.png',
        alterEgo: 'Tony Stark',
        alterEgoImg: 'images/heroes/mc01en_card_tony-stark.png',
        pack: 'Core Set',
    },
    {
        hero: 'Black Panther',
        heroImg: 'images/heroes/mc01en_card_black-panther.png',
        alterEgo: 'T\'Challa',
        alterEgoImg: 'images/heroes/mc01en_card_tchalla.png',
        pack: 'Core Set',
    },
    {
        hero: 'Captain America',
        heroImg: 'images/heroes/mc04en_card_captain-america.png',
        alterEgo: 'Steeve Rogers',
        alterEgoImg: 'images/heroes/mc04en_card_steve-rogers.png',
        pack: 'Captain America',
    },
    {
        hero: 'Ms. Marvel',
        heroImg: 'images/heroes/mc05en_ms-marvel.png',
        alterEgo: 'Kamala Khan',
        alterEgoImg: 'images/heroes/mc05en_kamala-khan.png',
        pack: 'Ms. Marvel',
    },
    {
        hero: 'Thor',
        heroImg: 'images/heroes/mc06en_a1_thor.png',
        alterEgo: 'Odinson',
        alterEgoImg: 'images/heroes/mc06en_a1_odinson.png',
        pack: 'Thor',
    },
    {
        hero: 'Black Widow',
        heroImg: 'images/heroes/mc07en_black-widow.png',
        alterEgo: 'Natasha Romanoff',
        alterEgoImg: 'images/heroes/mc07en_natasha-romanoff.png',
        pack: 'Black Widow',
    },
    {
        hero: 'Doctor Strange',
        heroImg: 'images/heroes/mc08en_doctor-strange.png',
        alterEgo: 'Stephen Strange',
        alterEgoImg: 'images/heroes/mc08en_stephen-strange.png',
        pack: 'Doctor Strange',
    },
    {
        hero: 'Hulk',
        heroImg: 'images/heroes/mc09en-hulk.png',
        alterEgo: 'Bruce Banner',
        alterEgoImg: 'images/heroes/mc09en_bruce-banner.png',
        pack: 'Hulk',
    },
    {
        hero: 'Hawkeye',
        heroImg: 'images/heroes/mc10en_hawkeye.png',
        alterEgo: 'Clint Barton',
        alterEgoImg: 'images/heroes/mc10en_clint-barton.png',
        pack: 'The Rise of Red Skull',
    },
    {
        hero: 'Spider-woman',
        heroImg: 'images/heroes/mc10en_spider-woman.png',
        alterEgo: 'Jessica Drew',
        alterEgoImg: 'images/heroes/mc10en_jessica-drew.png',
        pack: 'The Rise of Red Skull',
        numberOfAspects: 2,
    },
    {
        hero: 'Ant-Man',
        heroImg: 'images/heroes/mc11en_ant-man.png',
        alterEgo: 'Scott Lang',
        alterEgoImg: 'images/heroes/mc11en_scott-lang.png',
        pack: 'Ant-Man',
    },
    {
        hero: 'Wasp',
        heroImg: 'images/heroes/mc13en_wasp.png',
        alterEgo: 'Nadia Van Dyne',
        alterEgoImg: 'images/heroes/mc13en_nadia-van-dyne.png',
        pack: 'Wasp',
    },
    {
        hero: 'Quicksilver',
        heroImg: 'images/heroes/mc14en_quicksilver-hero.png',
        alterEgo: 'Pietro Maximoff',
        alterEgoImg: 'images/heroes/mc14en_pietro-maximoff-alter-ego.png',
        pack: 'Quicksilver',
    },
    {
        hero: 'Scarlet Witch',
        heroImg: 'images/heroes/mc15en_scarlet-witch.png',
        alterEgo: 'Wanda Maximoff',
        alterEgoImg: 'images/heroes/mc15en_wanda-maximoff.png',
        pack: 'Scarlet Witch',
    },
    {
        hero: 'Groot',
        heroImg: 'images/heroes/mc16en_groot-hero.png',
        alterEgo: 'Groot',
        alterEgoImg: 'images/heroes/mc16en_groot-alter-ego.png',
        pack: 'Galaxy\'s Most Wanted',
    },
    {
        hero: 'Rocket Racoon',
        heroImg: 'images/heroes/mc16en_rocket-racoon-hero.png',
        alterEgo: 'Rocket Racoon',
        alterEgoImg: 'images/heroes/mc16en_rocket-racoon-alter-ego.png',
        pack: 'Galaxy\'s Most Wanted',
    },
    {
        hero: 'Star-Lord',
        heroImg: 'images/heroes/mc17en_star-lord-hero.png',
        alterEgo: 'Peter Quill',
        alterEgoImg: 'images/heroes/mc17en_peter-quill.png',
        pack: 'Star-Lord',
    },
    {
        hero: 'Gamora',
        heroImg: 'images/heroes/mc18en_gamora-hero.png',
        alterEgo: 'Gamora',
        alterEgoImg: 'images/heroes/mc18en_gamora-alter-ego.png',
        pack: 'Gamora',
    },
    {
        hero: 'Drax',
        heroImg: 'images/heroes/mc19en_drax-hero.png',
        alterEgo: 'Drax',
        alterEgoImg: 'images/heroes/mc19en_drax-alter-ego.png',
        pack: 'Drax',
    },
    {
        hero: 'Venom',
        heroImg: 'images/heroes/mc20en_venom.png',
        alterEgo: 'Flash Thompson',
        alterEgoImg: 'images/heroes/mc20en_flash-thompson.png',
        pack: 'Venom',
    },
    {
        hero: 'Adam Warlock',
        heroImg: 'images/heroes/mc21en_adam-warlock-hero.png',
        alterEgo: 'Adam Warlock',
        alterEgoImg: 'images/heroes/mc21en_adam-warlock-alter-ego.png',
        pack: 'The Mad Titan\'s Shadow',
        numberOfAspects: 4,
    },
    {
        hero: 'Spectrum',
        heroImg: 'images/heroes/mc21en_spectrum.png',
        alterEgo: 'Monica Rambeau',
        alterEgoImg: 'images/heroes/mc21en_monica-rambeau.png',
        pack: 'The Mad Titan\'s Shadow',
    },
    {
        hero: 'Nebula',
        heroImg: 'images/heroes/mc22en_nebula-hero.png',
        alterEgo: 'Nebula',
        alterEgoImg: 'images/heroes/mc22en_nebula-alter-ego.png',
        pack: 'Nebula',
    },
    {
        hero: 'War Machine',
        heroImg: 'images/heroes/mc23en_war-machine-hero.png',
        alterEgo: 'James Rhodes',
        alterEgoImg: 'images/heroes/mc23en_war-machine-alter-ego.png',
        pack: 'War Machine',
    },
    {
        hero: 'Valkyrie',
        heroImg: 'images/heroes/mc25en_card_valkyrie.png',
        alterEgo: 'Brunnhilde',
        alterEgoImg: 'images/heroes/mc25en_card_brunnhilde.png',
        pack: 'Valkyrie',
    },
    {
        hero: 'Vision',
        heroImg: 'images/heroes/mc26en_cardsingle_vision_hero.png',
        alterEgo: 'Vision',
        alterEgoImg: 'images/heroes/mc26en_cardsingle_vision_alterego.png',
        pack: 'Vision',
    },
    {
        hero: 'Ghost-Spider',
        heroImg: 'images/heroes/mc27en_ghost_spider.png',
        alterEgo: 'Gwen Stacy',
        alterEgoImg: 'images/heroes/mc27en_gwen_stacy.png',
        pack: 'Sinister Motives',
    },
    {
        hero: 'Spider-man',
        heroImg: 'images/heroes/mc27en_spider-man.png',
        alterEgo: 'Miles Morales',
        alterEgoImg: 'images/heroes/mc27en_miles_morales.png',
        pack: 'Sinister Motives',
    },
    {
        hero: 'Nova',
        heroImg: 'images/heroes/mc28_nova_cardsingles__nova.png',
        alterEgo: 'Sam Alexander',
        alterEgoImg: 'images/heroes/mc28_nova_cardsingles__samalexander.png',
        pack: 'Nova',
    },
    {
        hero: 'Ironheart',
        heroImg: 'images/heroes/mc29en_ironheart_version_1_1a.png',
        alterEgo: 'Riri Williams',
        alterEgoImg: 'images/heroes/mc29en_riri_williams_version_1_1b.png',
        pack: 'Ironheart',
    },
    {
        hero: 'Spider-Ham',
        heroImg: 'images/heroes/mc30_spider-ham_cardsingles__spider-ham.png',
        alterEgo: 'Peter Porker',
        alterEgoImg: 'images/heroes/mc30_spider-ham_cardsingles__peterporker.png',
        pack: 'Spider-Ham',
    },
    {
        hero: 'SP//dr',
        heroImg: 'images/heroes/mc31_spdr_spdrsuit.png',
        alterEgo: 'Peni Parker',
        alterEgoImg: 'images/heroes/mc31_spdr_peniparker.png',
        pack: 'SP//dr',
    },
    {
        hero: 'Colossus',
        heroImg: 'images/heroes/mc32_colossus.png',
        alterEgo: 'Piotr Rasputin',
        alterEgoImg: 'images/heroes/mc32_piotr_rasputin.png',
        pack: 'Mutant Genesis',
    },
    {
        hero: 'Shadowcat',
        heroImg: 'images/heroes/mc32_shadowcat.png',
        alterEgo: 'Kitty Pryde',
        alterEgoImg: 'images/heroes/mc32_kitty_pryde.png',
        pack: 'Mutant Genesis',
    },
    {
        hero: 'Cyclops',
        heroImg: 'images/heroes/mc33_cyclops.png',
        alterEgo: 'Scott Summers',
        alterEgoImg: 'images/heroes/mc33_scott_summers.png',
        pack: 'Cyclops',
    },
    {
        hero: 'Phoenix',
        heroImg: 'images/heroes/mc34_phoenix.png',
        alterEgo: 'Jean Grey',
        alterEgoImg: 'images/heroes/mc34_jean_grey.png',
        pack: 'Phoenix',
    },    
    {
        hero: 'Wolverine',
        heroImg: 'images/heroes/mc35_wolverine_cards_wolverine.png',
        alterEgo: 'Logan',
        alterEgoImg: 'images/heroes/mc35_wolverine_cards_logan.png',
        pack: 'Wolverine',
    },
    {
        hero: 'Storm',
        heroImg: 'images/heroes/mc36_card_storm.png',
        alterEgo: 'Ororo Munroe',
        alterEgoImg: 'images/heroes/mc36_card_ororo_munroe.png',
        pack: 'Storm',
    },
    {
        hero: 'Gambit',
        heroImg: 'images/heroes/mc37_card_gambit.png',
        alterEgo: 'Remy Lebeau',
        alterEgoImg: 'images/heroes/mc37_card_remy_lebeau.png',
        pack: 'Gambit',
    },
    {
        hero: 'Rogue',
        heroImg: 'images/heroes/mc38_card_rogue.png',
        alterEgo: 'Anna Marie',
        alterEgoImg: 'images/heroes/mc38_card_anna_marie.png',
        pack: 'Rogue',
    },
    {
        hero: 'Cable',
        heroImg: 'images/heroes/mc40_cardsingles_cable.png',
        alterEgo: 'Nathan Summers',
        alterEgoImg: 'images/heroes/mc40_cardsingles_nathansummers.png',
        pack: 'NeXt Evolution'
    },
    {
        hero: 'Domino',
        heroImg: 'images/heroes/mc40_cardsingles_domino.png',
        alterEgo: 'Neena Thurman',
        alterEgoImg: 'images/heroes/mc40_cardsingles_neenathurman.png',
        pack: 'NeXt Evolution'
    },
    {
        hero: 'Psylocke',
        heroImg: 'images/heroes/mc41en_psylocke.png',
        alterEgo: 'Betsy Braddock',
        alterEgoImg: 'images/heroes/mc41en_betsy_braddock.png',
        pack: 'Psylocke'
    },
    {
        hero: 'Angel / Archangel',
        heroImg: 'images/heroes/mc42en_card_angel.png',
        alterEgo: 'Warren Worthington III',
        alterEgoImg: 'images/heroes/mc42en_card_warren_worthington_iii.png',
        pack: 'Angel'
    },
    {
        hero: 'X-23',
        heroImg: 'images/heroes/mc43_announce_cards_x-23.png',
        alterEgo: 'Laura Kinney',
        alterEgoImg: 'images/heroes/mc43_announce_cards_laurakinney.png',
        pack: 'X-23'
    },
    {
        hero: 'Deadpool',
        heroImg: 'images/heroes/mc44_announce_cards_deadpool.png',
        alterEgo: 'Wade Wilson',
        alterEgoImg: 'images/heroes/mc44_announce_cards_wadewilson.png',
        pack: 'Deadpool'
    },
    {
        hero: 'Bishop',
        heroImg: 'images/heroes/mc45_cards_bishop.png',
        alterEgo: 'Lucas Bishop',
        alterEgoImg: 'images/heroes/mc45_cards_lucasbishop.png',
        pack: 'Age of Apocalypse'
    },
    {
        hero: 'Magik',
        heroImg: 'images/heroes/mc45_cards_magik.png',
        alterEgo: 'Illiyana Rasputin',
        alterEgoImg: 'images/heroes/mc45_cards_illyanarasputin.png',
        pack: 'Age of Apocalypse'
    },
    {
        hero: 'Iceman',
        heroImg: 'images/heroes/mc46_announce_cards_iceman.png',
        alterEgo: 'Bobby Drake',
        alterEgoImg: 'images/heroes/mc46_announce_cards_bobbydrake.png',
        pack: 'Iceman'
    },
    {
        hero: 'Jubilee',
        heroImg: 'images/heroes/mc47_announce_cards_jubilee.png',
        alterEgo: 'Jubilation Lee',
        alterEgoImg: 'images/heroes/mc47_announce_cards_jubilationlee.png',
        pack: 'Jubilee'
    },
    {
        hero: 'Nightcrawler',
        heroImg: 'images/heroes/mc48_announcement_article_nightcrawler_01a_card.png',
        alterEgo: 'Kurt Wagner',
        alterEgoImg: 'images/heroes/mc48_announcement_article_kurt_wagner_01b_card.png',
        pack: 'Nightcrawler'
    },
    {
        hero: 'Magneto',
        heroImg: 'images/heroes/mc49_announce_cards_magneto.png',
        alterEgo: 'Erik Lehnsherr',
        alterEgoImg: 'images/heroes/mc49_announce_cards_eriklehnsherr.png',
        pack: 'Magneto'
    },
    {
        hero: 'Maria Hill',
        heroImg: 'images/heroes/mc50_mariahill_cards_mariahillhero.png',
        alterEgo: 'Maria Hill',
        alterEgoImg: 'images/heroes/mc50_mariahill_cards_mariahillalter.png',
        pack: 'Agents of S.H.I.E.L.D.'
    },
    {
        hero: 'Nick Fury',
        heroImg: 'images/heroes/mc50_article_nickfury_cards_nickfury_a.png',
        alterEgo: 'Nick Fury',
        alterEgoImg: 'images/heroes/mc50_article_nickfury_cards_nickfury_b.png',
        pack: 'Agents of S.H.I.E.L.D.'
    },
    {
        hero: 'Black Panther',
        heroImg: 'images/heroes/mc51_announce_cards_blackpanther_1_1.png',
        alterEgo: 'Shuri',
        alterEgoImg: 'images/heroes/mc51_announce_cards_shuri.png',
        pack: 'Black Panther'
    },
    {
        hero: 'Silk',
        heroImg: 'images/heroes/mc52_announcement_article_silk_1a.png',
        alterEgo: 'Cindy Moon',
        alterEgoImg: 'images/heroes/mc52_announcement_article_cindy_moon_1b.png',
        pack: 'Silk'
    },
    {
        hero: 'Falcon',
        heroImg: 'images/heroes/mc53_announcement_article_falcon_1a.png',
        alterEgo: 'Sam Wilson',
        alterEgoImg: 'images/heroes/mc53_announcement_article_sam_wilson_1b.png',
        pack: 'Falcon'
    },
    {
        hero: 'Winter Soldier',
        heroImg: 'images/heroes/mc54_announce_cards_wintersoldier.png',
        alterEgo: 'Bucky Barnes',
        alterEgoImg: 'images/heroes/mc54_announce_cards_buckybarnes.png',
        pack: 'Winter Soldier'
    },
    {
        hero: 'Tigra',
        heroImg: 'images/heroes/mc56_tigra_preview_article_card_tigra_1a.png',
        alterEgo: 'Greer Nelson',
        alterEgoImg: 'images/heroes/mc56_tigra_preview_article_card_greer_nelson_1b.png',
        pack: 'Civil War'
    },
    {
        hero: 'Hulkling',
        heroImg: 'images/heroes/mc56_hulkling_preview_article_card_hulkling_29a.png',
        alterEgo: 'Teddy Altman',
        alterEgoImg: 'images/heroes/mc56_hulkling_preview_article_card_teddy_altman_card_29b.png',
        pack: 'Civil War'
    },
    {
        hero: 'Wonder Man',
        heroImg: 'images/heroes/mc58_cards_wonderman.png',
        alterEgo: 'Simon Williams',
        alterEgoImg: 'images/heroes/mc58_cards_simonwilliams.png',
        pack: 'Wonder Man'
    },
    {
        hero: 'Hercules',
        heroImg: 'images/heroes/mc59_announce_cards_hercules_hero.png',
        alterEgo: 'Hercules',
        alterEgoImg: 'images/heroes/mc59_announce_cards_hercules_alterego.png',
        pack: 'Hercules'
    }
];
